import PropTypes from 'prop-types';
import React from 'react';

export const contactInfoDescription = ({ formName = 'disability claim' }) => (
  <p className="contact-info-description" id="contact-info">
    This is the contact information we have on file for you. Please review it to
    make sure the information below is correct. We’ll send any important
    information about your {formName} to your mailing address. After you submit
    your claim, we’ll send you a confirmation email to your email address.
  </p>
);

contactInfoDescription.propTypes = {
  formName: PropTypes.string,
};

export const contactInfoUpdateHelpDescription = () => (
  <div className="contact-info-help-description" id="help-description">
    <p>
      Any updates you make here to your contact information will only apply to
      this application. If you want to update your contact information for all
      of your VA accounts.
    </p>
    <p>
      <va-link
        href="/profile/contact-information"
        text="Visit your profile page"
      />
    </p>
  </div>
);
